// just a demonstration of how to customize the layout for a specific command
var t = () => {
    return `
<div class="content annotation-clear-tool" id="annotation-clear-tool"></div>
`;
}

export = t;     